<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M16 3a13 13 0 1013 13A13 13 0 0016 3zm4.71 16.29a1 1 0 010 1.42 1 1 0 01-1.42 0L16 17.41l-3.29 3.3a1 1 0 01-1.42 0 1 1 0 010-1.42l3.3-3.29-3.3-3.29a1 1 0 011.42-1.42l3.29 3.3 3.29-3.3a1 1 0 011.42 1.42L17.41 16z"/></svg>